'kiwi public';

import _asyncToGenerator from "@babel/runtime-corejs3/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime-corejs3/regenerator";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/find";
import _Promise from "@babel/runtime-corejs3/core-js-stable/promise";
import * as TextFormatting from '@/helpers/TextFormatting';
import * as Misc from '@/helpers/Misc';
import BouncerProvider from '@/libs/BouncerProvider';
import IPC from '@/libs/IPC';
var firstRun = true;
export default {
  data: function data() {
    return {
      hasOtherTab: false,
      addedNetworkToExisting: false,
      server: null,
      readyToShowOptions: false
    };
  },
  computed: {
    networks: function networks() {
      return this.$state.networks;
    },
    hasFragment: function hasFragment() {
      return window.location.hash && window.location.hash.length > 1;
    }
  },
  created: function created() {
    var _this = this;
    this.$state.setting('allowRegisterProtocolHandler', true);

    // Enable IPC listeners
    // This is used to allow opening new servers in existing tab
    IPC.init();
    var server = null;
    if (this.hasFragment) {
      server = this.parseFragment();
      this.server = server;
    }
    if (server) {
      this.findOtherTabs().then(function (hasOtherTab) {
        if (hasOtherTab) {
          _this.hasOtherTab = true;
          // Don't start the main kiwi app here as it's already open elsewhere
        } else {
          _this.listenForOtherTabs();
          _this.init();
        }
        _this.readyToShowOptions = true;
      });
    } else {
      this.listenForOtherTabs();
      this.init();
    }
  },
  methods: {
    listenForOtherTabs: function listenForOtherTabs() {
      var _this2 = this;
      IPC.on('message', function (e) {
        // respond to other tabs that are looking
        var msg = e.data;
        if (msg.type === 'ping' && _this2.networks.length > 0) {
          IPC.send({
            type: 'pong'
          });
        } else if (msg.type === 'addNetwork') {
          var _context;
          var network = _findInstanceProperty(_context = _this2.networks).call(_context, function (n) {
            return n.name === msg.server;
          });
          if (!network) {
            network = _this2.$state.addNetwork(msg.server, msg.nick || 'Guest' + Math.floor(Math.random() * 100), msg);
          }
          network.showServerBuffer('settings');
        }
      });
    },
    addEmptyNetwork: function addEmptyNetwork() {
      var nick = 'Guest' + Math.floor(Math.random() * 100);
      var network = this.$state.addNetwork(TextFormatting.t('new_network'), nick, {});
      network.showServerBuffer('settings');
    },
    findOtherTabs: function findOtherTabs() {
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", new _Promise(function (resolve, reject) {
                var handleIPCMessage = function handleIPCMessage(e) {
                  var msg = e.data;
                  if (msg.type === 'pong') {
                    clearTimeout(timer);
                    resolve(true);
                  }
                };
                var timer = setTimeout(function (e) {
                  IPC.removeListener('message', handleIPCMessage);
                  resolve(false);
                }, 200);
                IPC.on('message', handleIPCMessage);
                IPC.send({
                  type: 'ping'
                });
              }));
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee);
      }))();
    },
    addNetworkToExistingTab: function addNetworkToExistingTab() {
      var nick = 'Guest' + Math.floor(Math.random() * 100);
      var con = this.server;
      this.$state.addNetwork(TextFormatting.t('new_network'), nick, {});
      IPC.send({
        nick: nick,
        server: con.server,
        port: con.port,
        tls: con.tls,
        direct: con.direct,
        password: con.password || '',
        type: 'addNetwork'
      });
      window.location.hash = '';
      this.addedNetworkToExisting = true;
    },
    addNetwork: function addNetwork() {
      var temporary = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      if (!this.server) {
        return;
      }
      var con = this.server;
      if (temporary) {
        this.$state.persistence.storageKey = null;
        this.$state.persistence.forgetState();
        this.init();
      }
      var network = this.$state.getNetworkFromAddress(con.server);
      if (!network) {
        network = this.$state.addNetwork(con.server, con.nick || 'Guest' + Math.floor(Math.random() * 100), {
          server: con.server,
          port: con.port,
          tls: con.tls,
          direct: con.direct,
          password: con.password || ''
        });
      }
      window.location.hash = '';
      network.showServerBuffer('settings');
      this.$emit('start', {
        fallbackComponent: this.constructor
      });
    },
    parseFragment: function parseFragment() {
      if (window.location.hash.substr(1)) {
        var fragment = window.location.hash.substr(1);

        // Check to see if we're dealing with an encoded irc: uri (browsers do this
        // when clicking an IRC link)
        var uriCheck = fragment.substr(0, 7).toLowerCase();
        if (uriCheck === 'ircs%3a' || uriCheck.substr(0, 6) === 'irc%3a') {
          fragment = decodeURIComponent(fragment);
        }
        var connections = Misc.parseIrcUri(fragment);
        var con = connections[0];
        return con;
      }
      return null;
    },
    toggleStateBrowser: function toggleStateBrowser() {
      this.$state.$emit('statebrowser.show');
    },
    init: function init() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var persistSetting, _context3, controllerNet, bouncer;
        return _regeneratorRuntime.wrap(function (_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              if (firstRun) {
                _context4.next = 1;
                break;
              }
              return _context4.abrupt("return");
            case 1:
              firstRun = false;

              // persist the buffers in the state by default
              persistSetting = _this3.$state.settings.startupOptions.remember_buffers;
              if (typeof persistSetting === 'undefined') {
                _this3.$state.persistence.includeBuffers = true;
              } else {
                _this3.$state.persistence.includeBuffers = !!persistSetting;
              }
              _this3.$state.persistence.watchStateForChanges();
              if (_this3.$state.settings.startupOptions.bouncer) {
                controllerNet = _findInstanceProperty(_context3 = _this3.$state.networks).call(_context3, function (n) {
                  return n.is_bnc;
                });
                if (controllerNet) {
                  bouncer = new BouncerProvider(_this3.$state);
                  bouncer.enable(controllerNet.connection.server, controllerNet.connection.port, controllerNet.connection.tls, controllerNet.connection.direct, controllerNet.connection.path);
                }
              }
              // force restricted: false as users need access
              // to network settings to add a network
              _this3.$state.setSetting('settings.restricted', false);
              if (_this3.$state.networks.length) {
                // small screen devices cannot open the statebrowser unless a network is selected
                // if any network exists in saved config make that active on startup
                _this3.$state.setActiveBuffer(_this3.$state.networks[0].id, '*');
              }
              _this3.$emit('start', {
                fallbackComponent: _this3.constructor
              });
            case 2:
            case "end":
              return _context4.stop();
          }
        }, _callee2);
      }))();
    }
  }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
if(!window._kiwi_exports["components"]["startups"]) window._kiwi_exports["components"]["startups"] = {};
window._kiwi_exports["components"]["startups"]["Personal"]
window._kiwi_exports.components.startups.Personal = (typeof exports !== 'undefined' ? (exports.default || exports) : (typeof module !== 'undefined' && module.exports ? (module.exports.default || module.exports) : {}));
